export const searchInputClassName =
  '!w-full !bg-[#F5F5F5] !border-none !h-[48px] !mt-0';
